<template>
  <div>
   <headerNav title="代理签到记录"/>
    <van-cell title="累计签到积分" :value="abp.userInfo.integral+'分'" />
    <van-datetime-picker :show-toolbar="false" v-model="currentDate" @change="confirmPickerDate" type="year-month" title="选择年月" :min-date="minDate" :max-date="maxDate" :formatter="formatterDate" visible-item-count="1" />
    <van-calendar  title="签到记录" :min-date="calendarminDate" :max-date="calendarmaxDate" :poppable="false" :show-confirm="false" :style="{ height: '500px' }" 
    :default-date="defaultDate"  :show-title="false" type="multiple" @confirm="onConfirm" :formatter="formatter" :readonly="true" :show-subtitle="false">
    <div slot="footer">
    <van-button type="danger" block @click="signin">签到</van-button>
    </div>
    </van-calendar>

  </div>
</template>
<script>
export default {
  data() {
    return {
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(),
      currentDate: new Date(),
      calendarminDate: {},
      calendarmaxDate: {},
      records: [],
      defaultDate:[]
    };
  },
  created() {
    this.confirmPickerDate();
  },
  methods: {
    signin() {
      this.ajax.post("/api/services/app/PhoneUser/SignIn").then((x) => {
          this.$toast.success('签到成功')
          this.getUserInfo();
      });
    },
    formatter(day) {
      const year = day.date.getFullYear();
      const month = day.date.getMonth() + 1;
      const date = day.date.getDate();
      const time = `${year}${month}${date}`;
      if (this.records.find((x) => x.signDate == time)) {
        day.topInfo = "已签到";
        this.$forceUpdate();
      }
      return day;
    },
    formatterDate(type, val) {
      if (type === "year") {
        return `${val}年`;
      } else if (type === "month") {
        return `${val}月`;
      }
      return val;
    },
    onConfirm() {},
    changeDate() {
        let endtime=new Date(this.currentDate.getFullYear(), this.currentDate.getMonth()+1, 1);
      this.ajax.post("/api/services/app/PhoneUser/QueryMySignInRecord?start=" + this.calendarminDate.toISOString() + "&end=" + endtime.toISOString()).then((x) => {
        this.records = x.result;
        this.defaultDate=[];
        this.records.forEach(p=>{
            let str=p.signDate.toString();
            let y=str.substr(0,4);
            let m=Number(str.substr(4,2))-1;
            let d=str.substr(6,2);
            this.defaultDate.push(new Date(y,m,d))
        })
      });
    },
    confirmPickerDate() {
      this.calendarminDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth(), 1);
      this.calendarmaxDate = new Date(this.currentDate.getFullYear(), this.currentDate.getMonth() + 1, 0);
      this.changeDate();
    },
  },
};
</script>
<style scoped></style>
